function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 7.335V.665C0 .05.393-.18.879.152L5.636 3.4c.486.332.485.869 0 1.2L.879 7.848C.393 8.18 0 7.95 0 7.335z",
  fill: "#2F3947",
  fillRule: "evenodd"
});

var SvgArrowRight = function SvgArrowRight(props) {
  return React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='6px' height='8px' viewBox='0 0 6 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cdefs%3E%3C/defs%3E %3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg transform='translate(-9.000000, -8.000000)' fill='%232F3947'%3E %3Cpath d='M9,15.3349323 L9,8.66512066 C9,8.04927015 9.39334892,7.82048848 9.8785694,8.15180032 L14.6358931,11.4001333 C15.1216243,11.7317938 15.1211136,12.2686078 14.6358931,12.5999196 L9.8785694,15.8482526 C9.39283824,16.1799131 9,15.9497431 9,15.3349323 Z'%3E%3C/path%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgArrowRight as ReactComponent };